export interface ListingAlertSubscription {
  id?: string;
  email?: string;
  phone?: string;
  whatsappPhone?: string;
  channel?: 'whatsapp' | 'email' | 'both';
  category?: string;
  city?: string;
  citySlug?: string;
  quarter?: string;
  quarterSlug?: string;
  region?: string;
  maxBudget?: number | string;
  minBudget?: number | string;
  titreFoncierOnly?: boolean;
  language?: string;
  source?: string;
  created_at?: string;
}

const LOCAL_STORAGE_ALERTS_KEY = 'clm_saved_listing_alerts';

/**
 * Retrieve saved alerts from localStorage for the active user
 */
export function getSavedListingAlerts(): ListingAlertSubscription[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(LOCAL_STORAGE_ALERTS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

/**
 * Delete a saved alert from localStorage
 */
export function deleteSavedListingAlert(id: string): void {
  if (typeof window === 'undefined') return;
  try {
    const existing = getSavedListingAlerts();
    const filtered = existing.filter((a) => a.id !== id);
    localStorage.setItem(LOCAL_STORAGE_ALERTS_KEY, JSON.stringify(filtered));
  } catch {}
}
